import Rails from "@rails/ujs";
import {Controller} from "stimulus";
import QrScanner from "qr-scanner";

export default class extends Controller {
  static targets = [
    "statusText",
    "selectForm",
    "form",
    "firstStepDiv",
    "secondStepDiv",
    "lastStepDiv",
    "childDataDiv",
    "bankDataDiv",
    "additionalDeliveryAddress",
    "politicallyExposedPerson",
    "boPoliticallyExposedPerson",
    "additionalAddress",
    "deliveryAddressFields",
    "formObject",
    "partnerCard",
    "amount",
    "customAmount",
    "customMonthlyAmountRadio",
    "customMonthlyAmountInput",
    "customPaymentFee",
    "contractType",
    "moneyNe",
    "moneyNj",
    "moneyNb",
    "oneTimePayment",
    "setupFeeTotalDiv",
    "emailInput",
    "kycMonthlyPaymentInput",
    "kycOneTimePaymentInput",
    "customerModeDiv",
    "existingCustomerFields",
    "newCustomerFields",
    "bankDataModeDiv",
    "newWalletFields",
    "novemWalletOrdered",
    "hasWalletFields",
    "selectWalletFields",
    "existingBankDataFields",
    "newBankDataFields",
    "blockchainProductPrice",
    "blockchainTotalPrice",
    "blockchainQuantityInput",
    "blockchainProductId",
    "blockchainTitle",
    "blockchainLabelAgb",
    "blockchainLabelPurchase",
    "blockchainBundleFreezePrice",
    "commissionPercent",
    "walletDataForm"
  ];
  
  static value = {
    formObject: Object,
    identificationDocumentUrl: String,
    contractType: String,
    monthlyAmount: Number
  };
  
  connect() {
    // Disable back button
    if(window.location.href.includes("/customer_center/contracts/new")) {
      history.pushState(null, null, null);
      window.addEventListener("popstate", function() {
        history.pushState(null, null, null);
      });
    }
    
    // Disable leave alert on submit button
    $("#contract_form").submit(() => {
      window.onbeforeunload = null;

      // GA4 – Customer Center conversion
      const contractType =
          this.contractTypeValue ||
          document.querySelector("[name='contract[type]']:checked")?.value ||
          document.getElementById("customer_center_contract_type")?.dataset?.type;
      window.analytics?.trackContractCreated(contractType);
    });

    if(window.location.href.includes("/customer_center/blockchain_calculations") && document.getElementById("customer_center_contract_type").getAttribute("data-type") === "NvmContract") {
      this.customerWalletAddress();
    } else if (window.location.href.includes("/blockchain_calculations")) {
      this.hideWalletAddress();
    }

    // GA4 – Customer Center funnel: Step 1 (contract details)
    this.trackFunnelStep("cc_step_1_contract_details");
  }

  // === GA tracking helper ===
  trackFunnelStep(step) {
    const contractType =
        this.contractTypeValue ||
        document.querySelector("[name='contract[type]']:checked")?.value ||
        document.getElementById("customer_center_contract_type")?.dataset?.type;

    window.analytics?.trackContractFunnel?.(step, contractType);
  }

  hideWalletAddress() {
    const walletDataForm = document.querySelector("[data-target~='customer-center--contract.walletDataForm']");
    walletDataForm?.classList.add("d-none");
  }
  
  calculateBlockchainAmount() {
    const input = this.blockchainQuantityInputTarget;
    const total_amount = parseFloat(input.dataset.price * input.value);
    this.blockchainTotalPriceTarget.innerHTML = `${this.numberWithDelimiter(total_amount)}€`;

    const priceText = this.blockchainProductPriceTarget.textContent.trim();
    const normalizedPrice = priceText.replace("€", "").replace(/\./g, "").replace(",", ".");
    const tokenPrice = parseFloat(normalizedPrice);
    this.blockchainBundleFreezePriceTarget.value = Math.round(tokenPrice * 100);

    document.getElementById("contract_amount").value = total_amount.toString().replace(".", ",");
    if (total_amount < 100) {
      this.showError(this.blockchainQuantityInputTarget, "Kaufbetrag muss mindestens 100€ sein");
    } else {
      this.clearError(this.blockchainQuantityInputTarget);
    }
    const premiumContracts = ["NnnPlusContract", "NxagPlusContract", "NptPlusContract" , "NpdPlusContract"];
    if (premiumContracts.includes(document.getElementById("customer_center_contract_type").getAttribute("data-type"))) {
      this.calculatePremiumCommission();
    }
  }
  
  showError(inputElement, message) {
    inputElement.classList.add("is-invalid");
    const errorElement = $("#tokenTotalAmountError");
    errorElement.remove();
    $(inputElement).after(`<div id='tokenTotalAmountError' class='invalid-feedback'>${message}</div>`);
  }
  
  clearError(inputElement) {
    inputElement.classList.remove("is-invalid");
    $("#tokenTotalAmountError").remove();
  }
  
  selectCustomer(event) {
    event.preventDefault();
    if(window.location.href.includes("/customer_center/blockchain_calculations")) {
      this.customerWalletAddress();
    }
  }
  
  formToggler(event) {
    this.resetAllStatusText();
    this.closeAllForms();
    if(event.type === "mouseover") {
      this.activateForm();
    }
  }
  
  activateForm() {
    this.selectFormTarget.classList.remove("d-none");
    this.statusTextTarget.classList.add("d-none");
  }
  
  showFirstStep(event) {
    event.preventDefault();
    document.querySelectorAll(".second-step").forEach(e => e.classList.add("d-none"));
    document.querySelectorAll(".first-step").forEach(e => e.classList.remove("d-none"));
    document.querySelectorAll(".partner-card-title").forEach(e => e.classList.remove("d-none"));
    this.scrollToTopWindow();
    
    if (window.location.href.includes("/blockchain_calculations")) {
      this.initQr(document.querySelector("#videoQr"), $("#contract_wallet_address_address"), $("#qrStart"), $("#qrStop"));
    }
    
    const spanContainer = document.getElementById("select2-contract_customer_attributes_user_attributes_appeal-container");
    const firma = document.getElementById("company_name_firma");
    const observer = new MutationObserver(() => {
      if (spanContainer.innerText === "Firma") {
        firma.classList.remove("d-none");
      } else {
        firma.classList.add("d-none");
      }
    });
    
    observer.observe(spanContainer, {
      childList: true,
      subtree: true
    });
    
    window.onbeforeunload = () => {
      return window.i18n.t("view.admin.contract_controller.leave_this_page");
    };
  }
  
  returnToFirstStep(event) {
    event.preventDefault();
    document.querySelectorAll(".first-step").forEach(e => e.classList.remove("d-none"));
    document.querySelectorAll(".second-step").forEach(e => e.classList.add("d-none"));
    this.scrollToTop();
  }
  
  async showSecondStep(event) {
    event.preventDefault();
    if (this.invalidInputs === 0) {
      await this.handleBankData();
      await this.handleProduct();
      document.querySelectorAll(".second-step").forEach(e => e.classList.remove("d-none"));
      document.querySelectorAll(".first-step").forEach(e => e.classList.add("d-none"));
      this.scrollToTopWindow();
      // GA4 – Customer Center funnel: Step 2 (KYC + bank data)
      this.trackFunnelStep("cc_step_2_kyc_bank_data");
      const contractType = document.getElementById("customer_center_contract_type").getAttribute("data-type");
      const premiumContracts = ["NnnPlusContract", "NxagPlusContract", "NptPlusContract", "NpdPlusContract"];
      if (premiumContracts.includes(contractType)) {
        document.querySelectorAll(".premium-commission-block").forEach(e => e.classList.remove("d-none"));
      }
      if (window.location.href.includes("/blockchain_calculations")) {
        this.fillKycFields();
      }
    } else {
      this.scrollToInvalidInput();
    }
    
    const contractType = document.getElementById("customer_center_contract_type").getAttribute("data-type");
    const premiumContracts = ["NnnPlusContract", "NxagPlusContract", "NptPlusContract", "NpdPlusContract"];
    if (premiumContracts.includes(contractType)) {
      this.calculatePremiumCommission();
    }
  }
  
  returnToSecondStep(event) {
    this.scrollToTop();
    event.preventDefault();
    document.querySelectorAll(".second-step").forEach(e => e.classList.remove("d-none"));
    document.querySelectorAll(".last-step").forEach(e => e.classList.add("d-none"));
  }
  
  async showLastStep(event) {
    event.preventDefault();
    if (this.invalidInputs === 0) {
      await this.loadPreview();
      // GA4 – Customer Center funnel: Step 3 (preview)
      this.trackFunnelStep("cc_step_3_preview");
      document.querySelectorAll(".last-step").forEach(e => e.classList.remove("d-none"));
      document.querySelectorAll(".second-step").forEach(e => e.classList.add("d-none"));
      this.scrollToTopWindow();
    } else {
      this.scrollToInvalidInput();
    }
  }
  
  // load last step data
  async loadPreview() {
    const spinner = $("#loading-spinner");
    spinner.toggleClass("d-none d-flex");
    
    const lastStep = document.getElementById("last_customer_step");
    
    await $.ajax({
      url: "contracts/preview",
      type: "POST",
      processData: false,
      contentType: false,
      data: new FormData(document.querySelector("#contract_form")),
      dataType: "text",
      success: (response) => {
        lastStep.innerHTML = response;
      },
      error: () => {
        alert(window.i18n.t("view.admin.contract_controller.something_went_wrong"));
      },
      complete: () => {
        spinner.toggleClass("d-none d-flex");
      }
    });
  }
  
  fillKycFields() {
    const customer_id = $("#contract_customer_id").val();
    
    this.getCustomerKyc(customer_id).then((r) => {
      const excludedKeys = new Set([
        "id", "created_at", "updated_at", "contract_id", "job_start_date",
        "employment_type", "monthly_payment_input_cents",
        "one_time_payment_input_cents", "annual_salary",
        "other_capital", "monthly_payment", "one_time_payment",
        "one_time_payment_input", "monthly_payment_input"
      ]);
      
      for (const [key, value] of Object.entries(r)) {
        if (value && !excludedKeys.has(key)) {
          this.fillInputValue(key, value);
        }
      }
      
      this.fillDate(r["job_start_date"]);
      this.fillSelect("employment_type", r["employment_type"], this.employmentTypes());
      this.fillSelect("annual_salary", r["annual_salary"], this.salaryRanges());
    });
  }
  
  fillInputValue(key, value) {
    const name_of_input = `contract[kyc_attributes][${key}]`;
    const elements = document.getElementsByName(name_of_input);
    const element = elements[elements.length - 1];
    
    if (element) {
      element.value = value === true ? 1 : value;
      if (value === true) {
        element.checked = true;
      }
    }
  }
  
  fillDate(dateString) {
    const [year, month, day] = dateString.split("-").map(Number);
    this.setDateInput("contract_kyc_attributes_job_start_date_1i", year);
    this.setDateInput("contract_kyc_attributes_job_start_date_2i", month);
    this.setDateInput("contract_kyc_attributes_job_start_date_3i", day);
  }
  
  setDateInput(id, value) {
    const element = document.getElementById(id);
    element.value = value;
    document.getElementById(`select2-${id}-container`).textContent = value;
  }
  
  fillSelect(type, value, options) {
    const index = options[value];
    const element = document.getElementsByName(`contract[kyc_attributes][${type}]`)[index];
    
    if (element && !element.checked) {
      element.setAttribute("checked", "checked");
      element.checked = true;
    }
  }
  
  employmentTypes() {
    return {
      "employed": 1,
      "self_employed": 2,
      "civil_servant": 3,
      "pensioner": 4,
    };
  }
  
  salaryRanges() {
    return {
      "less_18k_euro": 1,
      "less_30k_euro": 2,
      "less_60k_euro": 3,
      "over_60k_euro": 4,
    };
  }
  
  async getCustomerKyc(customer_id) {
    const response = await fetch(`/customer_center/contracts/customer_kyc.json?customer_id_for_kyc=${customer_id}`);
    return await response.json();
  }
  
  async handleBankData() {
    this.bankDataModeDivTarget.classList.remove("d-none");
    await this.loadExistingCustomerBankData();
  }
  
  async handleProduct() {
    const contractType = document.getElementById("customer_center_contract_type").getAttribute("data-type");
    const validContracts = ["NnnContract", "NvmContract", "NlpContract", "NnnPlusContract", "NxagPlusContract", "NptPlusContract", "NpdPlusContract"];
    if (!validContracts.includes(contractType)) return;
    
    let csrfToken = document.head.querySelector("meta[name=\"csrf-token\"]") ? document.head.querySelector("meta[name=\"csrf-token\"]").content : "";
    if(csrfToken !== null) {
      await $.ajax({
        url: "/customer_center/contracts/fetch_product_data",
        type: "GET",
        data: { contract_type: contractType },
        headers: {
          "X-CSRF-TOKEN": csrfToken,
          "Content-Type": "application/json",
        },
        success: (response) => {
          this.blockchainProductIdTarget.value = response.id;
          this.blockchainProductPriceTarget.innerHTML = ` ${this.numberWithDelimiter(response.price)}€`;
          this.blockchainTitleTarget.innerHTML = response.title.replace(/Token/gi, "").trim();
          this.blockchainQuantityInputTarget.dataset.price = response.price;
          this.blockchainLabelAgbTarget.innerHTML = response.label_agb;
          this.blockchainLabelPurchaseTarget.innerHTML = response.label_blockchain_purchase;
          this.calculateBlockchainAmount();
        }
      });
    }
  }
  
  // return the amount of invalid inputs on current step
  get invalidInputs() {
    const invalidInputs = [];
    const blockhainInput = document.getElementById("blockchain-input");
    if(blockhainInput && blockhainInput.classList.contains("is-invalid")) {
      invalidInputs.push(blockhainInput);
    }
    document.querySelectorAll("input.required, textarea.required, select.required, div.form-group.upload.required button").forEach(function(item){
      if(item.offsetParent !== null && item.value.trim() === "" || item.type === "checkbox" && item.checked === false && item.nextSibling && item.nextSibling.offsetParent !== null) {
        item.classList.add("is-invalid");
        invalidInputs.push(item);
      } else {
        item.classList.remove("is-invalid");
      }
    });
    
    const wallet_address_field = $(".wallet_address:visible")[0];
    if (window.location.pathname.includes("/blockchain_calculations") && wallet_address_field) {
      const web3 = new window.Web3(window.Web3.givenProvider || "ws://localhost:8545");
      const wallet_alert = document.querySelector(".customer-wallet-alert");
      const customer_id = document.getElementById("contract_customer_id");
      
      if (wallet_address_field && web3.utils.isAddress(wallet_address_field.value)){
        wallet_address_field.classList.remove("is-invalid");
        wallet_alert.classList.add("d-none");
        customer_id.classList.remove("is-invalid");
      } else {
        wallet_address_field.classList.add("is-invalid");
        invalidInputs.push(wallet_address_field);
        wallet_alert.classList.remove("d-none");
        customer_id.classList.add("is-invalid");
      }
    }
    
    return invalidInputs.length;
  }
  
  // scroll to first invalid input
  scrollToInvalidInput() {
    let firstInvalid = $(".is-invalid:first");

    // Check if invalid element exists
    if (!firstInvalid.length) {
      return;
    }

    let targetElement = firstInvalid;

    if (firstInvalid.is("[type='checkbox']")) {
      targetElement = firstInvalid.closest(".form-check");
    }

    // Check if target element has offset
    if (!targetElement.length || !targetElement.offset()) {
      return;
    }

    let container = $([document.documentElement, document.body]);
    container.animate({
      scrollTop: targetElement.offset().top - 175
    }, 1000);
  }
  
  scrollToTop() {
    let container = $(".wrapper.full").length ? $(".wrapper.full") : $([document.documentElement, document.body]);
    container.scrollTop(0);
  }
  
  scrollToTopWindow() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }
  
  removeWalletAddressFields() {
    this.newWalletFieldsTarget.classList.add("d-none");
  }
  
  showWalletAddressFields() {
    this.newWalletFieldsTarget.classList.remove("d-none");
  }

  updateNovemWalletOrdered(e) {
    const selectedElement = e.target;
    this.novemWalletOrderedTarget.value = selectedElement.dataset.novemWalletOrderedValue;
  }
  
  toggleHasWalletAddressFields() {
    this.selectWalletFieldsTarget.classList.toggle("d-none");
    this.hasWalletFieldsTarget.classList.toggle("d-none");
  }
  
  toggleKycMonthlyPaymentInput(e) {
    if (e.target.checked) {
      this.kycMonthlyPaymentInputTarget.removeAttribute("readonly");
    } else {
      this.kycMonthlyPaymentInputTarget.setAttribute("readonly", "true");
    }
  }
  
  toggleKycOneTimePayment(e) {
    if (e.target.checked) {
      this.kycOneTimePaymentInputTarget.removeAttribute("readonly");
    } else {
      this.kycOneTimePaymentInputTarget.setAttribute("readonly", "true");
    }
  }
  
  onPoliticallyExposedPersonChanged(e) {
    this.togglePoliticallyExposedPersonChanged(e.target.checked);
  }
  
  togglePoliticallyExposedPersonChanged(show) {
    this.politicallyExposedPersonTarget.classList.toggle("d-none", !show);
  }
  
  onTransactionCompletionChanged(e) {
    if (e.currentTarget.value === "as_agent") {
      $("#contract_kyc_attributes_trading_own_bill").removeAttr("checked");
      $("#contract_kyc_attributes_trading_foreign_bill").attr("checked", "checked");
    } else {
      $("#contract_kyc_attributes_trading_foreign_bill").removeAttr("checked");
      $("#contract_kyc_attributes_trading_own_bill").attr("checked", "checked");
    }
  }
  
  onBoPoliticallyExposedPersonChanged(e) {
    this.toggleBoPoliticallyExposedPersonChanged(e.target.checked);
  }
  
  toggleBoPoliticallyExposedPersonChanged(show) {
    this.boPoliticallyExposedPersonTarget.classList.toggle("d-none", !show);
  }
  
  closeAllForms(){
    document.querySelectorAll(".contract-status-select-form").forEach(e => e.classList.add("d-none"));
  }
  
  successHandler(response) {
    this.statusTextTarget.innerHTML = response.detail[0].message;
  }
  
  errorHandler(response, status, xhr) {
    console.error(xhr.responseText);
  }
  
  onTokenCountCalculateOption(e){
    const quantity = document.getElementById("contract_bundles_attributes_0_bundle_items_attributes_0_quantity");
    const freezePrice = document.getElementById("contract_bundles_attributes_0_bundle_items_attributes_0_freeze_price");
    if(e.target.checked){
      quantity.disabled = true;
      freezePrice.disabled = true;
    } else {
      quantity.disabled = false;
      freezePrice.disabled = false;
    }
  }
  
  submitForm(e) {
    e.preventDefault();
    Rails.fire(this.formTarget, "submit");
    this.closeAllForms();
    this.statusTextTarget.className = "contract-status-text";
  }
  
  calculatePremiumCommission () {
    let targetValue = document.getElementById("customer_center_premium-commission").getAttribute("data-value");
    this.getPartnerCommission(targetValue);
  }
  
  async getPartnerCommission(target_commission) {
    const priceValue = parseFloat(this.blockchainTotalPriceTarget.innerText.replace(".", "").replace(",", ".").replace("€", ""));
    const commissionValue = (priceValue / 100) * parseInt(target_commission);
    document.querySelector("#contract_premium_commission_commission_value").value = commissionValue.toFixed(2);
  }
  
  contractTypeChanged(event) {
    this.contractTypeValue = event.currentTarget.value;
    this.trackFunnelStep("cc_step_1_contract_details");
  }
  
  onBankDataModeChanged() {
    this.existingBankDataFieldsTarget.classList.toggle("d-none");
    this.newBankDataFieldsTarget.classList.toggle("d-none");
  }
  
  async loadParentData() {
    const partner_id = document.getElementById("partner_parent_id").value;
    const card = document.getElementById("short-partner-card");
    if (partner_id) {
      card.innerHTML = await fetch(`/partners/${partner_id}/short_card`)
        .then(response => response.text())
        .then(html => { return html; });
    } else {
      card.innerHTML = "";
    }
  }
  
  async loadExistingCustomerBankData() {
    const customer_id = $("#contract_customer_id").val();
    let csrfToken = document.head.querySelector("meta[name=\"csrf-token\"]") ? document.head.querySelector("meta[name=\"csrf-token\"]").content : "";

    if(csrfToken !== null) {
      await $.ajax({
        url: "/customer_center/contracts/customer_bank_data",
        type: "POST",
        headers: {
          "X-CSRF-TOKEN": csrfToken,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ id: customer_id }),
        success: (response) => {
          response.bank_data.forEach(bk => {
            $("#contract_bank_datum_id").append( new Option(bk.label, bk.id, false, false)).trigger("change");
          });
        }
      });
    }
  }
  
  // transform 1000 to 1.000,00
  numberWithDelimiter(x) {
    return x.toFixed(2).toString().replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  async customerWalletAddress() {
    const csrfToken = document.head.querySelector("meta[name='csrf-token']")?.content || "";
    const needWalletAddress = document.getElementById("contract_need_wallet_address_0");
    const contractCustomerId = document.getElementById("contract_customer_id");
    const walletSelect = document.getElementById("contract_existing_wallet_address");

    try {
      const response = await fetch(`${window.location.origin}/customer_center/contracts/customer_data`, {
        method: "GET",
        headers: {
          "X-CSRF-TOKEN": csrfToken,
          "Content-Type": "application/json"
        }
      });
      const data = await response.json();

      walletSelect.innerHTML = "";
      const walletAddresses = data.customer.wallet_addresses || [];
      walletAddresses.forEach(addr => {
        const option = new Option(addr, addr, false, false);
        walletSelect.appendChild(option);
      });

      if(walletAddresses.length > 0){
        walletSelect.value = walletAddresses[0];
      }

      this.setValidationState(contractCustomerId, walletAddresses.length > 0);
      this.toggleVisibility(".customer-address-alert", walletAddresses.length === 0);

      if (data.pending_cold_wallet === false && needWalletAddress) {
        needWalletAddress.parentElement.classList.add("d-none");
      }
    } catch (error) {
      console.error("Failed to fetch customer data", error);
    }
  }

  toggleClass(element, className, condition) {
    element.classList.toggle(className, condition);
  }
  
  toggleVisibility(selector, visible) {
    document.querySelectorAll(selector).forEach(e => {
      e.classList.toggle("d-none", !visible);
    });
  }
  
  setValidationState(inputElement, isValid) {
    this.toggleClass(inputElement, "is-invalid", !isValid);
  }
  
  isTokenTotalAmountValid() {
    const contractType = document.getElementById("customer_center_contract_type").getAttribute("data-type");
    const validContracts = ["NnnContract", "NvmContract", "NlpContract", "NnnPlusContract", "NxagPlusContract", "NptPlusContract"];
    if (!validContracts.includes(contractType)) return true;
    
    const minTokenTotalAmount = 100;
    const input = this.blockchainQuantityInputTarget;
    const totalAmount = parseFloat(input.dataset.price * input.value);
    if (totalAmount < 100) {
      this.showError(this.blockchainQuantityInputTarget, "Kaufbetrag muss mindestens 100€ sein");
    } else {
      this.clearError(this.blockchainQuantityInputTarget);
    }
    return totalAmount >= minTokenTotalAmount;
  }
  
  initQr = (video, walletInput, startBtn, stopBtn) => {
    const qrScanner = new QrScanner(
      video,
      (result) => {
        walletInput.val(result.data);
        qrScanner.stop();
        video.style.height = "0px";
      },
      {
        highlightScanRegion: true
      }
    );
    
    startBtn.on("click", () => {
      video.style.height = "auto";
      qrScanner.start();
    });
    
    stopBtn.on("click", () => {
      video.style.height = "0px";
      qrScanner.stop();
    });
  };
}
